import { render, staticRenderFns } from "./ShowBooking.vue?vue&type=template&id=64f19c1a&lang=pug&"
import script from "./ShowBooking.vue?vue&type=script&lang=js&"
export * from "./ShowBooking.vue?vue&type=script&lang=js&"
import style0 from "./ShowBooking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports